import React from 'react';
import styled from 'styled-components';
import Box from '../../../../../../components/box';
import { H1, P, Cols } from '../../../../components';
import Container from '../../../../../../components/container';
import { HEADER_HEIGHT, HEADER_ADDITIONAL_HEIGHT } from '../../../../../../components/header';
import Form from './components/Form';
import CustomButton from '../../../../../forgot-password/CustomButton';

const ContainerStyled = styled(Box)`
  display: flex;
  align-items: center;
  background-image: url(${process.env.NEXT_PUBLIC_PUBLIC_URL}/img/reviews/intro-image-2.jpg);
  background-size: cover;
  min-height: 687px;
  background-position: center;
  padding-top: ${HEADER_HEIGHT + HEADER_ADDITIONAL_HEIGHT - 64}px;
`;

const CustomButtonStyled = styled(CustomButton)`
  width: 100%;
  border-radius: 48px;
  margin-top: 24px;
  &:hover {
    color: white;
  }
  @media screen and (min-width: 600px) {
    width: 256px;
    margin-top: 0;
    margin-left: auto;
  }
`;

const MainSection = props => {
  const ITEMS = [
    <Box white textAlign="left">
      <H1 textAlign="left">{props.title}</H1>

      <P mt={5} fontSize={22} lineHeight="30px">
        Rejoins <b>la communauté</b> d’étudiant.e.s <b>Clevermate</b> et <b>donne des cours particuliers</b> sur les matières académiques. Trouve des élèves proches de chez toi qui te correspondent.
        Fais le choix <b>d’une activité stimulante et valorisante</b> pour booster tes revenus.
      </P>

      <P mt={3}>
        Nous sommes toujours là pour toi. <b>On t’attend !</b>
      </P>

      <P mt={6} flex style={{ flexFlow: 'wrap' }} alignItemsCenter>
        <Box component="b" fontSize={40}>760€</Box>&nbsp;estimé par mois
        <CustomButtonStyled href="/sign-up#signupTutor" color="secondary" style={{ padding: 16 }}>
          Devenir Tuteur
        </CustomButtonStyled>
      </P>
    </Box>,

    props.isAuthenticated
      ? null
      : (
        <Box>
          <Form showAlert={props.showAlert} />
        </Box>
      )
  ].filter(item => item).map(description => ({description, descriptionProps: {mt: 0}}));

  return (
    <ContainerStyled>
      <Container>
        <Cols items={ITEMS} my={3} justifyContentCenter alignItemsCenter />
      </Container>
    </ContainerStyled>
  );
}

MainSection.defaultProps = {
  title: 'Donner des cours et  booster tes revenus',
  isAuthenticated: true,
};

export default MainSection;